import { useMutation } from "@apollo/client/react";
import { useNotificationState } from "hooks/state";
import flatten from "lodash/flatten";
import values from "lodash/values";
import GqlError from "utils/GqlError";
import { DeleteDowntimeReason } from "./downtimeReason.gql";

export default function useDeleteDowntimeReason() {
  const { setNotification } = useNotificationState();
  const [deleteDowntimeReason] = useMutation(DeleteDowntimeReason, {
    onCompleted: ({ deleteDowntimeReason: { code, reason } }) => {
      setNotification({
        title: `${reason} \u00B7 ${code} was successfully deleted.`,
        type: "success",
      });
    },
    onError: (error) => {
      GqlError.handler(error, (errors) => {
        const allErrors = flatten(values(errors)).join("\n");

        setNotification({
          message: allErrors,
          title: "Unable to delete downtime reason",
          type: "danger",
        });
      });
    },
  });

  return (options) => deleteDowntimeReason(options);
}
